import { motion } from 'framer-motion';
import { Award, Users, Wrench, TrendingUp, Shield, MapPin } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const ICON_MAP = { Award, Users, Wrench, TrendingUp, Shield, MapPin };

export default function WhyUsSection() {
  const { t } = useLanguage();
  return (
    <section data-testid="why-us-section" className="py-16 lg:py-24" style={{ backgroundColor: '#0D4D2B' }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-xs font-semibold uppercase tracking-[0.2em]" style={{ color: '#FCD34D' }}>{t.whyUs.badge}</span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2 text-white">{t.whyUs.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.whyUs.items.map((item, i) => {
            const Icon = ICON_MAP[item.icon] || Award;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="p-6 rounded-xl border card-hover"
                style={{ backgroundColor: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.1)' }}
              >
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: 'rgba(217,119,6,0.2)' }}>
                  <Icon size={24} style={{ color: '#FCD34D' }} />
                </div>
                <h3 className="font-heading font-semibold text-white mb-2">{item.title}</h3>
                <p className="text-sm leading-relaxed" style={{ color: '#A4C8AF' }}>{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
